<template>
  <div class="row wrapper_input justify-content-between align-items-center toggle optional" :class="wrapperClass">
    <label :for="inputId" class="col pe-0 col-form-label text-break toggle optional d-flex align-items-center gap-2">
      <span v-html="label" />
      <slot name="hint" />
    </label>
    <div class="col-auto row mx-0 justify-content-end align-items-center">
      <div class="col-auto form-check form-switch">
        <div v-if="stateLabels" class="toggle-wrapper" :class="{ checked: modelValue }">
          <input
            :id="inputId"
            type="checkbox"
            class="form-check-input toggle"
            :class="inputClass"
            :checked="modelValue"
            :style="{ '--form-toggle-after': `'${modelValue ? stateLabels.on : stateLabels.off}'` }"
            @change="onChange"
          />
        </div>
        <input
          v-else
          :id="inputId"
          type="checkbox"
          class="form-check-input toggle"
          :class="inputClass"
          :checked="modelValue"
          @change="onChange"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useId } from 'vue'

const inputId = `toggle_${useId()}`

withDefaults(
  defineProps<{
    modelValue?: boolean
    label?: string
    stateLabels?: { on: string; off: string }
    inputClass?: string
    wrapperClass?: string
  }>(),
  { modelValue: false, label: '', stateLabels: undefined, inputClass: '', wrapperClass: 'mb-3' },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

function onChange(event: Event): void {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.checked)
}
</script>
